import Vue from 'vue'
import VueRouter from 'vue-router'
import vueXstore from '@/store/index';
import authService from '@/services/authService';

Vue.use(VueRouter)

let routes = [
	{
		path: '/login',
		name: 'Login',
		layout: 'default',
		meta: { layoutClass: 'login-fullscreen' },
		component: () => import('../views/Login.vue'),
	},
	{
		// will match everything
		path: '*',
		component: () => import('../views/404.vue'),
	},
	// {
	// 	path: '/',
	// 	name: 'Home',
	// 	redirect: '/dashboard',
	// 	meta: {
	// 		requiresAuth: true,
	// 		permission: ['staff', 'faculty', 'student']
	// 	},
	// },
	// {
	// 	path: '/dashboard',
	// 	name: 'Portal',
	// 	layout: "dashboard",
	// 	meta: {
	// 		requiresAuth: true,
	// 		permission: ['staff', 'faculty', 'student']
	// 	},
	// 	// route level code-splitting
	// 	// this generates a separate chunk (about.[hash].js) for this route
	// 	// which is lazy-loaded when the route is visited.
	// 	component: () => import(/* webpackChunkName: "dashboard" */ '../muic/portal/mainportal.vue'),
	// },
	// my muic : router
	{
		path: '/',
		name: 'Home',
		redirect: '/dashboard',
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff']
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Dashboard.vue'),
	},
	{
		path: '/alumni',
		name: 'Alumni Data',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff']
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/alumni-data/AlumniData.vue'),
	},
	{
		path: '/alumni/formprofile',
		name: 'Alumni Form Profile',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff']
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/alumni-data/tabsInfo/mainForm.vue'),
	},
	{
		path: '/alumni/form',
		name: 'Alumni Form',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff']
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/alumni-data/AlumniForm.vue'),
	},
	{
		path: '/achievement',
		name: 'Alumni Achievement',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff']
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/achievement/AchievementData.vue'),
	},
	{
		path: '/activity',
		name: 'Alumni Activity',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff']
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/activity/ActivityData.vue'),
	},
	{
		path: '/activity/form',
		name: 'Alumni Activity Form',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff']
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/activity/ActivityForm.vue'),
	},
	{
		path: '/engagement',
		name: 'Engagement Report',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff']
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/engagement/ReportData.vue'),
	},
	{
		path: '/engagement/record',
		name: 'Engagement Report',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff']
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/engagement/EngagementRecord.vue'),
	},
	// {
	// 	path: '/employmentsurvey',
	// 	name: 'Employment Survey',
	// 	layout: "dashboard",
	// 	meta: {
	// 		requiresAuth: true,
	// 		permission: ['staff']
	// 	},
	// 	component: () => import('../views/employment/EmploymentData.vue'),
	// },
	{
		path: '/layout',
		name: 'Layout',
		layout: "dashboard",
		meta: {
			requiresAuth: true
		},
		component: () => import('../views/Layout.vue'),
	},
	// {
	// 	path: '/tables',
	// 	name: 'Tables',
	// 	layout: "dashboard",
	// 	meta: {
	// 		requiresAuth: true
	// 	},
	// 	component: () => import('../views/Tables.vue'),
	// },
	// {
	// 	path: '/billing',
	// 	name: 'Billing',
	// 	layout: "dashboard",
	// 	meta: {
	// 		requiresAuth: true
	// 	},
	// 	component: () => import('../views/Billing.vue'),
	// },
	// {
	// 	path: '/rtl',
	// 	name: 'RTL',
	// 	layout: "dashboard-rtl",
	// 	meta: {
	// 		layoutClass: 'dashboard-rtl',
	// 		requiresAuth: true
	// 	},
	// 	component: () => import('../views/RTL.vue'),
	// },
	// {
	// 	path: '/sign-in',
	// 	name: 'Sign-In',
	// 	meta: {
	// 		// requiresAuth: true
	// 	},
	// 	component: () => import('../views/Sign-In.vue'),
	// },
	// {
	// 	path: '/sign-up',
	// 	name: 'Sign-Up',
	// 	meta: {
	// 		layoutClass: 'layout-sign-up',
	// 		// requiresAuth: true
	// 	},
	// 	component: () => import('../views/Sign-Up.vue'),
	// },

	// survey
	{
		path: '/student_graduate',
		name: 'Employment Survey',
		meta: {
			layoutClass: 'layout-sign-up',
			requiresAuth: true,
			permission: ['student']
		},
		component: () => import('../views/employment/mainsurvey.vue'),
	},
]

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute(route, parentLayout = "default") {
	route.meta = route.meta || {};
	route.meta.layout = route.layout || parentLayout;

	if (route.children) {
		route.children = route.children.map((childRoute) => addLayoutToRoute(childRoute, route.meta.layout));
	}
	return route;
}

routes = routes.map((route) => addLayoutToRoute(route));

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}
})

const whoami = async () => {
	try {
		const res = await Vue.axios.get('/whoami/')
		if (res.status === 200) {
			return res.data;
		}
		return false;
	}
	catch (error) {
		return false;
	}
}

router.beforeEach(async (to, from, next) => {
	await authService.initialize()
	const postLoginPath = authService.consumePostLoginPath()
	if (postLoginPath && postLoginPath !== to.fullPath) return next(postLoginPath)

	if (to.path === '/login') {
		return authService.isAuthenticated() && !to.query.error
			? next(authService.consumeReturnPath())
			: next()
	}

	if (!to.matched.some(record => record.meta.requiresAuth)) return next()

	if (!authService.isAuthenticated()) {
		authService.rememberReturnPath(to.fullPath)
		return next('/login')
	}

	const res = await whoami()
	if (!res) {
		authService.rememberReturnPath(to.fullPath)
		return next({ path: '/login', query: { error: 'access_denied' } })
	}

	vueXstore.dispatch('setRoleUser', {
		username: res.username,
		roles: res.roles,
		permissions: res.permissions,
		codeId: res.usercode,
		flexible: res.flexible
	})

	const staffOnlyPaths = [
		'/', '/dashboard', '/alumni', '/alumni/formprofile', '/alumni/form',
		'/achievement', '/activity', '/activity/form', '/engagement', '/engagement/record'
	]
	if (staffOnlyPaths.includes(`${to.matched[0].path}`) && !(res.roles || []).includes('staff')) {
		return next('/student_graduate')
	}

	return next()
})

export default router
